<div class="flex-shrink-0 main-height pb-60">
  <ds365-header></ds365-header>
  <main role="main" [ds365Loader]="loading">
    <router-outlet></router-outlet>
  </main>
</div>
<ds365-footer></ds365-footer>
